import React, { useState } from 'react'
import { Container, Row, Col, Button, Form, InputGroup, FormControl } from 'react-bootstrap'
import "assets/css/Auth/loginForgot.css"
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import logo from "../../assets/img/Logo.png"
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";


export default function ForgotPassword() {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [validated, setValidated] = useState(false);

    const toastConfig = {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
    };
    
    const handleClickResetPassword = (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            toast.error("Please fill all fields", toastConfig);
        } else if (password !== confirmPassword) {
            toast.error("Passwords do not match", toastConfig);
        } else {
            toast.success("Password Changed", toastConfig);
        }
    };
    
   
    

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    return (
        <Container fluid>
            <Row className='vh-100'>
                <Col md={7} sm={5} className='d-none d-md-block custom-bg'></Col>
                <Col className='d-flex flex-column justify-content-center align-items-center'>
                    <img src={logo} alt='logo' width={320} className='mb-5' />
                    <div className='custom-spacer'></div>
                    <div className='text-center w-50'>
                        <strong className=' w-50 '>Reset Your Password?</strong>
                        <p>Please enter the your email to sign in.</p>
                        <Form noValidate validated={validated} onSubmit={handleClickResetPassword}>
                            <Form.Group className="mb-3" controlId="formPlaintextPassword">
                                <InputGroup className="custom-border-input shadow">
                                    <FormControl
                                        type={passwordVisible ? 'text' : 'password'}
                                        placeholder="Pasword"
                                        name='password'
                                        className="custom-border p-2"
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                    <InputGroup.Text className='custom-border-icons'>
                                        {passwordVisible ? (
                                            <BsEyeSlash onClick={togglePasswordVisibility} />
                                        ) : (
                                            <BsEye onClick={togglePasswordVisibility} />
                                        )}
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formPlaintextPassword">
                                <InputGroup className="custom-border-input shadow">
                                    <FormControl
                                        type='password'
                                        placeholder="Pasword"
                                        name='confirmPassword'
                                        className="custom-border p-2"
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                    />
                                    {/* <InputGroup.Text className='custom-border-icons'>
                                    {passwordVisible ? (
                                        <BsEyeSlash onClick={togglePasswordVisibility}  />
                                    ) : (
                                        <BsEye onClick={togglePasswordVisibility}  />
                                    )}
                                </InputGroup.Text> */}
                                </InputGroup>
                            </Form.Group>
                            <Button variant=" w-100 p-2 rounded-pill custom-button" type='submit'>Send</Button>
                        </Form>
                    </div>
                    <Link to="/" className='text-center custom-text mt-2 w-50 '>Back to login?</Link>

                </Col>
            </Row>
        </Container>
    )
}
